"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=14271%3A1182))
 * @trackcomponent
 * @lastsynced 2026-09-30T17:16:17.000Z
 * @optimized using svgo:^3.3.4
 */
export const BSREyeClosed = createSVGIcon(
  <path
    d="m21 12 .595.457.35-.457-.35-.457zM3 12l-.595-.457-.35.457.35.457zm9.898-4.437a.75.75 0 1 0 .204-1.486L13 6.82zm4.393.124a.75.75 0 1 0-.795 1.272l.398-.636zm-12.789 6.96a.75.75 0 1 0 .996-1.121l-.498.56zm3.778.84a.75.75 0 0 0-.699 1.328l.35-.664zm-3.768 1.944a.75.75 0 1 0 .976 1.138L5 18zM19.488 6.569a.75.75 0 0 0-.976-1.138L19 6zM21 12l-.595-.457v.001l-.007.009-.03.038-.127.154a17.606 17.606 0 0 1-2.348 2.296C16.315 15.313 14.231 16.5 12 16.5V18c2.74 0 5.156-1.438 6.835-2.791a19 19 0 0 0 2.558-2.503q.096-.114.146-.179l.04-.05.01-.014.004-.004.001-.001v-.001zM3 12l.595.457v-.001l.007-.009a8 8 0 0 1 .157-.192A17.606 17.606 0 0 1 6.107 9.96C7.685 8.687 9.769 7.5 12 7.5V6C9.26 6 6.844 7.438 5.165 8.791a19 19 0 0 0-2.558 2.503 10 10 0 0 0-.186.229l-.01.014-.004.004-.001.001v.001zm9-5.25v.75q.453 0 .898.063L13 6.82l.102-.743A8 8 0 0 0 12 6zm4.893 1.573-.397.636c1.171.733 2.153 1.61 2.844 2.31a17 17 0 0 1 1.002 1.108l.05.063.011.014.002.003L21 12l.595-.457h-.001q0-.002-.002-.003 0-.003-.005-.006l-.079-.1a18.115 18.115 0 0 0-1.101-1.22c-.744-.752-1.815-1.713-3.116-2.527zM5 14.087l.498-.561a18 18 0 0 1-1.409-1.4 14 14 0 0 1-.467-.548L3.6 11.55l-.005-.006v-.001L3 12l-.595.457.002.002.002.003.038.049.111.136a19.263 19.263 0 0 0 1.944 2zm7 3.163v-.75c-1.309 0-2.571-.408-3.72-1.013l-.35.664-.349.664C8.876 17.496 10.38 18 12 18zm1.768-3.607-.53-.53c-.61.609-1.678.62-2.387-.089l-.53.53-.53.53c1.243 1.244 3.261 1.335 4.507.09zm-.089-3.447-.53.53c.71.71.698 1.777.089 2.386l.53.53.53.531c1.246-1.246 1.155-3.264-.088-4.508zM5 18l.488.57 14-12L19 6l-.488-.57-14 12z"
    fill="currentColor"
  />,
  "BSREyeClosed",
  {
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
